module.exports = __webpack_public_path__ + "img/icon_merchants.8ea50021.svg";